import { Bell, LogOut, Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/shared/components/ui/button";
import { logout } from "@/modules/auth/api/auth";

type TopbarProps = { onMenuClick?: () => void };

export function Topbar({ onMenuClick }: TopbarProps) {
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate("/");
  }

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-border/80 bg-[#f9fbff]/90 px-4 backdrop-blur supports-[backdrop-filter]:bg-[#f9fbff]/80 lg:h-20 lg:px-6">
      {/* Hamburger — mobile only */}
      <button
        type="button"
        onClick={onMenuClick}
        className="grid h-10 w-10 place-items-center rounded-xl border border-border bg-white text-[#536d96] transition-colors hover:bg-[#edf2fb] lg:hidden"
        aria-label="Open menu"
      >
        <Menu className="h-5 w-5" />
      </button>

      <div className="ml-auto flex items-center gap-2 lg:gap-3">
        <Button variant="outline" size="icon" className="h-10 w-10 rounded-xl bg-white text-[#536d96] lg:h-11 lg:w-11">
          <Bell className="h-5 w-5" />
        </Button>
        <div className="hidden items-center gap-3 border-l border-border/70 pl-3 md:flex">
          <div className="text-right">
            <p className="text-sm font-semibold text-foreground">Admin User</p>
            <p className="text-xs text-muted-foreground">Club Manager</p>
          </div>
          <div className="grid h-11 w-11 place-items-center rounded-full bg-primary text-sm font-semibold text-white">
            AD
          </div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-10 w-10 rounded-xl text-[#5d759e] lg:h-11 lg:w-11"
          onClick={() => void handleLogout()}
        >
          <LogOut className="h-5 w-5" />
        </Button>
      </div>
    </header>
  );
}
